import type { StatusTone } from '@/components/ui/Chip';
import type { InvoiceStatus } from '@/hooks/useInvoices';

export function invoiceStatusTone(status: InvoiceStatus): StatusTone {
  switch (status) {
    case 'draft':
      return 'draft';
    case 'issued':
      return 'upcoming';
    case 'overdue':
    case 'expired_pay_link':
      return 'red';
    case 'partial':
      return 'draft';
    case 'paid':
      return 'completed';
    case 'cancelled':
    case 'void':
      return 'cancelled';
    case 'refunded':
      return 'coral';
    default: {
      const unexpected: never = status;
      return unexpected;
    }
  }
}
